import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { mutationKeys } from '../mutationKeys';

type ApproveTogglePayload = {
  uuids: string[];
  approved: boolean;
};

const approveToggleEmployeeTimeOffs = async (payload: ApproveTogglePayload) => {
  const response = await CustomAxios.post('employee_time_offs/approve_toggle', payload);
  return response.data;
};

export function useApproveToggleEmployeeTimeOffs(onSuccessCallback?: () => void) {
  return useMutation({
    mutationKey: [mutationKeys.approveToggleEmployeeTimeOffs],
    mutationFn: approveToggleEmployeeTimeOffs,
    onSuccess: () => {
      onSuccessCallback?.();
    },
  });
}
